export default __webpack_public_path__ + "a18930ba1894df501c1a6ed2a0718ef7.svg";